import { Controller } from "@hotwired/stimulus"

// Applies the contents page's custom header/body text colors by setting CSS
// custom properties (CSP-safe, no inline style) that the .contents-*-tint classes
// read. Font and size are safelisted utility classes rendered server-side; only
// the hex colors need a variable. Re-applied on every Turbo render because a morph
// refresh wipes the inline vars and does not re-run connect() (same as cover-plate).
export default class extends Controller {
  static values = { headerColor: String, bodyColor: String }

  connect() {
    this.apply()
  }

  apply() {
    this.set("--contents-header-color", this.headerColorValue)
    this.set("--contents-body-color", this.bodyColorValue)
  }

  set(name, value) {
    if (value) this.element.style.setProperty(name, value)
    else this.element.style.removeProperty(name)
  }
}
